import React, {
  useState,
  useEffect
} from 'react';
import './App.css';
import Web3 from 'web3'
import {
  ethers
} from 'ethers'
import contrato_token from '../abis/airnft.json'
import contrato_staking from '../abis/StakingToken.json'

const App = () => {

  const [airNft, setAirNft] = useState(null)
  const [stakeTokens, setStakeTokens] = useState(null)
  const [eth_account, setAccount] = useState(0)
  const [e_message, set_message] = useState(0)

  const [mtx, setMtx] = useState(0)
  const [tokenInput, setTokenInput] = useState('')


  useEffect(() => {
    setInterval(ViewTokenBalance,3000)
  },[stakeTokens])

  const loadWeb3 = async () => {
    if (window.ethereum) {
      window.web3 = new Web3(window.ethereum)
      await window.ethereum.enable()
    } else if (window.web3) {
      window.web3 = new Web3(window.web3.currentProvider)
    } else {
      window.alert('Non ethereum browser detected. You should consider trying Metamask!')
    }
    const accounts = await window.web3.eth.getAccounts()
    const account = accounts[0]
    setAccount(account)
  }

  // Carga de los datos de la Blockchain

  const loadBlockchainData = async () => {

    const abi = contrato_token
    const abi2 = contrato_staking

    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    const contract_airnft = new ethers.Contract('0xF5db804101d8600c26598A1Ba465166c33CdAA4b', abi, signer)    
    const contract_reward = new ethers.Contract('0x33a472b995CdDa964f09dc0A7609b6303A519892', abi2, signer)    

    setAirNft(contract_airnft)
    await setStakeTokens(contract_reward)
  }


  const AddToken = async () => {
    airNft.getApproved(tokenInput)
      .then(async (res) => {
        console.log(eth_account,res);
        if(res !== eth_account)
        {
          set_message("Waiting for Acception")
          let tx1 = await airNft.approve('0x33a472b995CdDa964f09dc0A7609b6303A519892', tokenInput)          
          set_message("Approving now")
          await tx1.wait();
          set_message("Approved")
        }
        set_message("Waiting for Acception for Stake")
        let tx2 = await stakeTokens.stake(tokenInput)               
        set_message("Staking now")
        await tx2.wait();
        set_message("Staked")
        ViewTokenBalance();
      })
  }

  const ViewTokenBalance = async () => {        
    if(stakeTokens)
    {
      const data = await stakeTokens.stakedNFTSByUser(eth_account);
      let sum = 0;
      for(let i = 0; i < data.length; i++)
      {
        let t_num = Number(data[i]._hex);
        const data2 = await stakeTokens.pendingRewards(eth_account,t_num);
        sum += window.web3.utils.fromWei(data2._hex, 'ether')        
      }
      const response = await stakeTokens.balanceOf(eth_account)
      const hex = response._hex;
      const num = window.web3.utils.fromWei(hex, 'ether')
      if (response == null) {
        setMtx(0)
      } else {
        setMtx(Number(num) + Number(sum));
      }
    }    
  }

  const LoadingAll = async () => {
    await loadWeb3()
    await loadBlockchainData()
    await ViewTokenBalance()
    //await ViewTokens()
  }

  useEffect(() => {
    LoadingAll()
  }, [])

  return ( <div style = {{width:'100%',minHeight:'900px', height:'100%', display:'flex', flexFlow:'column',alignItems:'center', backgroundColor:'#FF8C0E'}}>
  <h1 style = {{color:'white', margin:'0 auto', marginTop:'50px', fontSize:'55px'}} >STAKE NOW</h1>
  <div style = {{width:'50%', height:'150px', display:'flex',flexFlow:'row', justifyContent:'space-between', margin:'0 auto' }}>
    <input style = {{width:'250px', height:'50px', marginTop:'100px',border:'none', borderRadius:'10px', paddingLeft:'45px'}} placeholder = "Paste here your NFTID" type = "text" onChange={(event)=>{setTokenInput(event.target.value)}} />
    <button style = {{width:'250px', height:'50px', backgroundColor:'#3E3F5E', marginTop:'100px', color:'white', border:'none',fontSize:'20px', borderRadius:'10px'}} onClick = {()=>{AddToken()}}>Stake your NFT</button>
  </div>
  <div style = {{width:'50%', height:'50px', display:'flex',flexFlow:'row', justifyContent:'space-between', margin:'0 auto' }}>
    <p style = {{color:'white', fontSize:'10px', marginTop:'18px'}}>*You can find the NFTID in the "info" section on AIRNFT</p>
    <p></p>
  </div>
  <h5 style = {{color:'white', fontSize:'30px', marginTop:'25px'}}>YOUR REWARDS:</h5>
  <h5 style = {{color:'white', fontSize:'30px', marginTop:'5px',borderRadius:'10px', border:'2px solid white', width:'220px', height:'50px', padding:'5px', textAlign:'center', }}>{mtx} MTX</h5>
  <p style = {{color:'red', fontSize:'10px'}}>{e_message}</p>
  <p style = {{color:'white', fontSize:'10px'}}>*It will automatically refresh every 24h</p>  
  <h5 style = {{color:'white', fontSize:'30px', marginTop:'10px'}}>You can claim your NFTs and rewards in:</h5>
  <iframe style = {{ margin:'0 auto',marginTop:'10px',position:'relative', left:'20px'}} src="https://free.timeanddate.com/countdown/i89bzlr1/cf12/cm0/cu4/ct0/cs0/ca0/co0/cr0/ss0/cacfff/cpc000/pct/tcfff/fs100/szw576/szh243/iso2022-08-31T00:00:00" allowtransparency="true" frameborder="0" width="217" height="52"></iframe>
</div>
  );

}

export default App;